import { GET_CMA_REPORT_TRANSACTIONS } from '@modules/reports/cma-reports/cmaReportsQueries';

type TransactionsMutationResult = {
  data?: {
    update_cma_reports_by_pk?: {
      cma_property_transactions?: unknown;
    } | null;
  } | null;
};

export const refetchTransactionsUnlessReturned =
  (cmaReportId: string) => (result: TransactionsMutationResult) =>
    Array.isArray(
      result.data?.update_cma_reports_by_pk?.cma_property_transactions,
    )
      ? []
      : [
          {
            query: GET_CMA_REPORT_TRANSACTIONS,
            variables: { id: cmaReportId },
          },
        ];
